import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { CollectionApi } from 'api';
import { SearchCollectionsQueryType } from 'types';

function useGetAll(query: SearchCollectionsQueryType) {
  return useAuthQuery(
    getQueryKeys(KEY).list({ ...query }),
    () => CollectionApi.getAll(query),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetAll;
